import Skeleton2 from "components/Skeleton2";
import React from "react";

export default function Playground() {
  return (
    <div>
      <Skeleton2 />
    </div>
  );
}
